import { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Search } from 'lucide-react';
import SearchPalette from './SearchPalette';
import NotificationBell from './NotificationBell';
import FilterPillStrip from './FilterPillStrip';
import SavedViewsMenu from './SavedViewsMenu';

/**
 * Fixed-position top bar with global ⌘K search trigger + notification bell.
 * Complexity minimised: this component only owns the search-open state and
 * composes the two sub-components.
 */
const TopBar = () => {
  const [searchOpen, setSearchOpen] = useState(false);

  // ⌘K / Ctrl+K global shortcut
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setSearchOpen(true);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      <div className="fixed top-0 right-0 z-30 flex items-center gap-2 p-3 lg:pr-6" data-testid="top-bar">
        <FilterPillStrip />
        <SavedViewsMenu />
        <Button
          variant="outline" size="sm"
          className="gap-2 hidden sm:inline-flex"
          onClick={() => setSearchOpen(true)}
          data-testid="global-search-trigger"
        >
          <Search className="h-4 w-4" />
          <span className="text-xs text-muted-foreground">Search</span>
          <kbd className="pointer-events-none hidden md:inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground">
            ⌘K
          </kbd>
        </Button>
        <Button
          variant="outline" size="icon"
          className="sm:hidden"
          onClick={() => setSearchOpen(true)}
          data-testid="global-search-trigger-mobile"
        >
          <Search className="h-4 w-4" />
        </Button>
        <NotificationBell />
      </div>

      <SearchPalette open={searchOpen} onOpenChange={setSearchOpen} />
    </>
  );
};

export default TopBar;
